import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6871677e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HeaderProfile" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "HeaderProfile__avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" })
], -1))
const _hoisted_4 = { class: "HeaderProfile__content" }
const _hoisted_5 = { class: "content__name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down HeaderProfile__arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.account.state.user_name), 1)
      ])
    ]),
    _hoisted_6
  ]))
}